import LinkedList from '../../utils/linkedList';
import FrontCubeData from '../../frontCubeData/index';
import { __walk__, __getLinks__ } from './db';
import { cubeModify } from '../../update/cubeModify';

function createLink(cubeIds: CubeId[]): LinkedListInstance {
    let link: LinkedListInstance = new LinkedList();

    cubeIds.forEach((cubeId: CubeId): void => {
        link.append(cubeId);
    });

    return link;
}

function getGroupList(): CubeId[][] {
    let result: CubeId[][] = [];

    __walk__((link: LinkedListInstance, index: number): void => {
        result.push(link.valueList());
    });

    return result;
}

function updateLayoutKey(links: LinkedListInstance[]): void {
    links.forEach((link: LinkedListInstance, index: number): void => {
        if (link.length < 2) {
            return;
        }
        let xplaceType: any;
        let xdirection: any;

        link.walk((layer: CubeId, index: number): void => {
            if (index === 0) {
                xplaceType = FrontCubeData.getValue(layer, 'xplaceType');
                xdirection = FrontCubeData.getValue(layer, 'xdirection');
                return;
            }

            cubeModify(layer, {
                xplaceType,
                xdirection
            });
        });
    });
}

function updateGroupedKey(links: LinkedListInstance[]): void {
    links.forEach((link: LinkedListInstance, index: number): void => {
        if (link.length === 1) {
            let layer: CubeId = link.getElementAt(0).val;

            cubeModify(layer, {
                grouped: 0
            });
            return;
        }

        link.walk((layerId: CubeId, index: number) => {
            cubeModify(layerId, {
                grouped: 1
            });
        });
    });
}

function setGroupedKey(layers: CubeId[], val: number): void {
    layers.forEach((layer: CubeId): void => {
        cubeModify(layer, {
            grouped: val
        });
    });
}

function layerLink(layerId: CubeId): LinkedListInstance|null {
    let links: LinkedListInstance[] = __getLinks__();

    for (let i = 0; i < links.length; i++) {
        if (links[i].has(layerId)) {
            return links[i];
        }
    }

    return null;
}

export {
    createLink,
    getGroupList,
    updateLayoutKey,
    updateGroupedKey,
    layerLink,
    setGroupedKey
};
